import { v4 as uuid } from 'uuid';
import { VectorSVGMaterial } from '@meitu/saas-editor-core/es/layers/vector-layer';
import { parseServerLayersToClient } from '@meitu/saas-editor-core/es/version-parse';
import { ILayerProps, MaterialIdsType } from '@meitu/saas-editor-core/es/version-types';
import { getElementTypeAndExtObj } from '@meitu/xdesign-widgets';
import { Image } from '@/editor/components/select-image-modal/type';
import { type IEditor } from '@/instance';

const useReplaceLayer = () => {
    const replaceLayer = async (
        editor: IEditor,
        activeLayer: ILayerProps,
        image: Image,
        replaceImageCb?: () => void,
    ) => {
        const { elementType, extObj } = getElementTypeAndExtObj(image.ext);
        if (elementType === 'common') {
            const newMaterialIds: Record<string, string[]> = {};
            if (image.id) {
                newMaterialIds[MaterialIdsType.PHOTO_MATERIAL] = [image.id];
            }
            await editor.imageLayer.replaceImage(
                image.thumbnail,
                activeLayer.id,
                image.width,
                image.height,
                true,
                newMaterialIds,
            );
            replaceImageCb?.();
            return;
        }

        if (elementType === 'svg') {
            const { ext, id: materialId } = image;
            if (!ext) return;

            const material = JSON.parse(ext);
            const url = material['image'];
            const info = material['info'] as VectorSVGMaterial['info'];

            if (!url || !info) return;

            const vectorMaterial: VectorSVGMaterial = {
                id: materialId,
                url,
                info,
            };
            editor.vectorLayer.replaceImageLayerToVectorLayer(activeLayer, vectorMaterial);
            return;
        }

        if (elementType === 'media') {
            //如果上传是media图层
            const data = {
                url: image.url || '',
                info: {
                    naturalWidth: image.width,
                    naturalHeight: image.height,
                    mediaType: extObj.mediaType,
                },
            };
            editor.mediaLayer.replaceImg2Media(activeLayer.id, image.id, data);
            return;
        }

        if (elementType === 'layer') {
            // 旧数据不符合服务端规范, 旧数据是直接存clientLayer的
            const isOldLayerData = !!extObj.data;
            console.log('elementType====', elementType, extObj);

            const clientLayer = isOldLayerData
                ? (extObj as ILayerProps)
                : parseServerLayersToClient(
                      {
                          width: 0,
                          height: 0,
                          layers: [extObj],
                      },
                      '',
                  )[0];

            clientLayer.id = uuid();
            if (activeLayer) {
                clientLayer.top = activeLayer.top;
                clientLayer.left = activeLayer.left;
            }

            editor.services.stage.replaceLayer(activeLayer.id, clientLayer);
        }
    };
    return {
        replaceLayer,
    };
};
export default useReplaceLayer;
